import React, { useEffect, useState, useMemo, useCallback } from "react";
import Sidebar from "./Sidebar";
import { API_BASE_URL } from "../config";
import { Session } from "./utils/session";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function UserTimeReport() {

  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [taskName, setTaskName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [doctors, setDoctors] = useState([]);

  const authHeaders = useMemo(() => ({
    Authorization: `Bearer ${Session.getToken()}`,
    "Content-Type": "application/json"
  }), []);


  useEffect(() => {
    fetch(`${API_BASE_URL}/api/Members/Users_List?workspaceName=IME`, { headers: authHeaders })
      .then(res => res.json())
      .then(data => setUsers(data || []))
      .catch(err => console.error("User load error:", err));
  }, [authHeaders]);

  useEffect(() => {

    fetch(`${API_BASE_URL}/api/Members/doctorslistunique`, {
      headers: {
        Authorization: `Bearer ${Session.getToken()}`
      }
    })
      .then(res => res.json())
      .then(data => setDoctors(Array.isArray(data) ? data : []))
      .catch(err => console.error("Doctor load error:", err));

  }, []);
  const loadReport = useCallback(async () => {
  try {
 setLoading(true);
    const params = new URLSearchParams();

    if (selectedUserId) params.append("userId", selectedUserId);
    if (taskName) params.append("taskName", taskName);
    if (doctorName) params.append("doctorName", doctorName);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const url = `${API_BASE_URL}/api/TimeReports/UserTimeReport_List?${params.toString()}`;

    const res = await fetch(url, { headers: authHeaders });
console.log("Task Filter:", taskName);
console.log("URL:", url);
    if (!res.ok) {
      console.error("API Error:", res.status);
      return;
    }

    const result = await res.json();
    console.log("Report Data:", result);

    setData(Array.isArray(result) ? result : []);

  } catch (err) {
    console.error("Report load error:", err);
  }
  finally {
    setLoading(false);
  }
}, [selectedUserId,taskName,doctorName, startDate, endDate, authHeaders]);

  useEffect(() => {
    loadReport();
  }, [loadReport]);

  useEffect(() => {
    const overlay = document.getElementById('sidebar-overlay');
    if (overlay) {
      overlay.style.display = showMobileSidebar ? 'block' : 'none';
    }
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      if (showMobileSidebar) sidebar.classList.add('show-mobile');
      else sidebar.classList.remove('show-mobile');
      if (hideDesktop) sidebar.classList.add('hide-desktop');
      else sidebar.classList.remove('hide-desktop');
    }
    const content = document.getElementById('content');
    if (content) {
      if (hideDesktop) content.classList.add('full-width');
      else content.classList.remove('full-width');
    }
  }, [showMobileSidebar, hideDesktop]);

  const toggleSidebar = () => {
    if (window.innerWidth <= 991) {
      setShowMobileSidebar((s) => !s);
    } else {
      setHideDesktop((s) => !s);
    }
  };
const exportToExcel = () => {
  if (!data.length) {
    alert("No data available to export");
    return;
  }

  const exportData = data.map(item => ({
    User: item.userName,
    Task: item.taskName,
    StartDate: item.startDateTime
      ? new Date(item.startDateTime).toLocaleString()
      : "",
    EndDate: item.endDateTime
      ? new Date(item.endDateTime).toLocaleString()
      : "",
    TotalTime: item.totalTime
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "User Time Report"
  );

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array"
  });

  const blob = new Blob(
    [excelBuffer],
    {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  );

  saveAs(
    blob,
    `UserTimeReport_${new Date().toISOString().split("T")[0]}.xlsx`
  );
};
  return (
    <div>
      <div id="sidebar-overlay" onClick={() => setShowMobileSidebar(false)} />
      <div id="sidebar"><Sidebar /></div>

      <div id="content">
        <div className="d-flex align-items-center mb-3">
         <button type="button" id="sidebarCollapse" className="btn btn-toggle" onClick={toggleSidebar} aria-label="Toggle sidebar">
              <i className="fas fa-bars" />
            </button>
          <span className="text-muted small">
            <i className="fas fa-chevron-left" /> Back
          </span>
        </div>

        <h2 className="mb-4 fw-bold">User Time Report</h2>

        <div className="main-card">
          <div className="panel panel-default">
            <div className="panel-body p-4">
              <div className="row mb-4 align-items-end">

                <div className="col-md-2">
                  <label className="form-label">User</label>
                  <select
                    className="form-select"
                    value={selectedUserId}
                    onChange={(e) => setSelectedUserId(e.target.value)}
                  >
                    <option value="">All Users</option>
                    {users.map(u => (
                      <option key={u.userId} value={u.userId}>
                        {u.userName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Doctor</label>
                  <select
                    className="form-select"
                    value={doctorName}
                    onChange={(e) => setDoctorName(e.target.value)}
                  >
                    <option value="">All Doctors</option>

                    {doctors.map((d, index) => (
                      <option key={index} value={d}>
                        {d}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Task</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Task Name"
                    value={taskName}
                    onChange={(e) => setTaskName(e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    max={endDate || ""}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    min={startDate || ""}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label d-block">&nbsp;</label>
                  <button
                    className="btn btn-success"
                    onClick={exportToExcel}
                    style={{ width: "140px" }}
                  >
                    <i className="fas fa-file-excel me-2"></i>
                    Export
                  </button>
                </div>

              </div>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                  <img src="/Images/loader.gif" alt="loading" style={{ width: "80px" }} />
                </div>
              ) : (
                <table className="table table-custom table-hover">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Task</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Total Time</th>
                    </tr>
                  </thead>

                  <tbody>

                    {data.length === 0 && (
                      <tr>
                        <td colSpan="5" className="text-center text-muted py-3">
                          No Data Found
                        </td>
                      </tr>
                    )}

                    {data.map((item, i) => {
                      const isTotal = item.userName === "TOTAL";

                      return (
                        <tr
                          key={i}
                          style={{
                            fontWeight: isTotal ? "bold" : "normal",
                            backgroundColor: isTotal ? "#f8f9fa" : "transparent"
                          }}
                        >
                          <td>{item.userName}</td>
                          <td>{isTotal ? "" : item.taskName}</td>

                          <td>
                            {isTotal
                              ? ""
                              : item.startDateTime
                                ? new Date(item.startDateTime).toLocaleString()
                                : "-"}
                          </td>

                          <td>
                            {isTotal
                              ? ""
                              : item.endDateTime
                                ? new Date(item.endDateTime).toLocaleString()
                                : "-"}
                          </td>

                          <td style={{ color: isTotal ? "#0d6efd" : "inherit" }}>
                            {item.totalTime}
                          </td>
                        </tr>
                      );
                    })}

                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}